import { FelaCSS, FelaCSSWithCustomSelectors, colors } from '@bridebook/ui';

interface IStyles {
  descriptionWrap: (isBordered: boolean) => FelaCSS;
  messageWrap: (isHidden: boolean) => FelaCSS;
  experienceWrap: (isHidden: boolean, hasExpandOrCollapseButton: boolean) => FelaCSS;
  buttonWrap: (isHidden: boolean, isCollapsed: boolean) => FelaCSS;
  descriptionRichText: FelaCSSWithCustomSelectors;
}

const styles = (): IStyles => ({
  descriptionWrap: (isBordered) => ({
    whiteSpace: 'pre-wrap',

    ...(isBordered && {
      paddingBottom: '16px',
      marginBottom: '24px',
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: colors.space15,
    }),
  }),

  messageWrap: (isVisible: boolean) => ({
    visibility: isVisible ? 'visible' : 'hidden',
    height: isVisible ? 'inherit' : 0,
  }),

  experienceWrap: (isVisible: boolean, hasExpandOrCollapseButton: boolean) => ({
    visibility: isVisible ? 'visible' : 'hidden',
    height: isVisible ? 'inherit' : 0,
    marginBottom: isVisible && !hasExpandOrCollapseButton ? 8 : 0,

    maxWidthTabletSm: {
      marginBottom: '0',
    },
  }),

  buttonWrap: (isVisible: boolean, isCollapsed: boolean) => ({
    display: isVisible ? 'flex' : 'none',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: 'max-content',
    width: 'fit-content',

    maxWidthMobile: {
      marginLeft: isCollapsed ? 0 : 4,
      marginVertical: 4,
    },

    minWidthTablet: {
      marginTop: isCollapsed ? 4 : 0,
      marginBottom: isCollapsed ? 2 : 4,
    },
  }),
  descriptionRichText: {
    fontDefault: 16,
    lineHeight: '1.875em',
    wordSpacing: '0.0233em',

    maxWidthMobile: {
      overflow: 'hidden', // osx horizontal bounce
    },

    desktopDesign: {
      marginRight: '20px',
    },

    '& ol': {
      display: 'block',
      marginTop: 0,
      paddingLeft: 10,
      marginBottom: 8,

      '& li': {
        listStyleType: 'decimal',
      },
    },

    '& ul': {
      listStyleType: 'disc',
      display: 'block',
      paddingLeft: 10,
      marginBottom: 8,

      '& li': {
        listStyleType: 'disc',
      },
    },

    '& h3': {
      marginTop: 4,
      marginBottom: 4,
      fontDefaultSemiBold: 22,
      lineHeight: '28px',

      maxWidthMobile: {
        marginTop: 2,
        marginBottom: 2,
        fontDefaultSemiBold: 18,
        lineHeight: '24px',
      },
    },

    '& p': {
      marginBottom: 5,
    },

    '& b, & strong': {
      fontDefaultSemiBold: 'inherit',
    },
  },
});

export default styles;
